import { useState } from "react";
import { Minus, Plus } from "lucide-react";

/** A collapsed window. Long copy, demos and billboards live inside one of these, under the thing you came for. */
export function Fold({ title, kicker, children, testid = "fold", defaultOpen = false, id, open: controlled, onToggle }) {
    const [own, setOwn] = useState(defaultOpen);
    const open = controlled ?? own;
    const toggle = () => (onToggle ? onToggle(!open) : setOwn((o) => !o));
    return (
        <section id={id} className="border-t border-zinc-200" data-testid={testid} data-open={open ? "true" : "false"}>
            <button type="button" onClick={toggle} aria-expanded={open} data-testid={`${testid}-toggle`}
                className="mx-auto flex w-full max-w-7xl items-center justify-between gap-4 px-4 py-5 text-left sm:px-6">
                <span className="min-w-0">
                    {kicker && <span className="block font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-500">{kicker}</span>}
                    <span className="block font-display text-base font-black uppercase tracking-tight text-zinc-900 md:text-lg">{title}</span>
                </span>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center border-2 border-zinc-900 text-zinc-900 transition-colors hover:bg-ink hover:text-[#fff]">
                    {open ? <Minus size={18} /> : <Plus size={18} />}
                </span>
            </button>
            {open && <div className="pb-10" data-testid={`${testid}-body`}>{children}</div>}
        </section>
    );
}

/** The same window, but it opens on a page section (a hash link) and its body is already constrained. */
export function FoldBody({ children, className = "" }) {
    return <div className={`mx-auto max-w-7xl px-4 sm:px-6 ${className}`}>{children}</div>;
}
